// NOT SURE IT IS USED

import { Link } from 'react-router-dom'
import Breadcrumb from '@/components/ui/Breadcrumb'
import LoadingSpinner from '@/components/ui/LoadingSpinner'
import RecentArticles from '@/components/sections/RecentArticles'
import Newsletter from '@/components/sections/Newsletter'
import { usePublishedStrategicPillars } from '@/lib/api/hooks/strategic-pillar'
import { parseHtmlString } from '@/utils/helpers/html'

export default function StrategicPillarsOverview() {
  
  const filters = {}


  const { data: strategicPillarsData, isLoading } = usePublishedStrategicPillars(
    { page: 1, size: 20 },
    filters
  )


  const apiStrategicPillars = strategicPillarsData?.data?.data || []


  const pillars = apiStrategicPillars.map((pillar) => {
    let textContent = ''
    if (pillar.content) {
      if (typeof document !== 'undefined') {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = pillar.content
        textContent = tempDiv.textContent || tempDiv.innerText || ''
      } else {
        // Fallback: strip HTML tags using regex (for SSR)  
        textContent = pillar.content.replace(/<[^>]*>/g, '').trim()
      }
    }
    
    return {
      id: pillar.strategicPillarId,
      title: pillar.title,
      description: textContent ? textContent.substring(0, 200) + (textContent.length > 200 ? '...' : '') : '',
      image: pillar.coverImage,
      slug: pillar.strategicPillarId,
      tags: pillar.articleTag || []
    }
  })

  const breadcrumbItems = [
    { label: 'Home', href: '/' },
    { label: 'Strategic Pillars', href: '', active: true }
  ]

  // Show loading state
  if (isLoading) {
    return (
      <LoadingSpinner fullScreen size="lg" message="Loading strategic pillars..." />
    )
  }

  return (
    <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
      {/* Breadcrumb */}
      <div className=" mb-5  ">
        <Breadcrumb items={breadcrumbItems} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-16">
        {/* Main Content */}
        <div className="lg:col-span-2">
          {/* Introduction */}
          <div className="mb-16 space-y-6">
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-normal font-pt-serif text-gray-900 leading-tight lg:leading-12">
              Harnessing Space Technology for Africa’s Sustainable Development
            </h1>
            <div className="space-y-12">
              <p className="text-lg font-normal font-satoshi text-gray-900 leading-relaxed max-w-2xl">
               The African Space Agency (AfSA) is the continental space agency of the African Union. It was established to coordinate and implement Africa's space ambitions. Headquartered in Egypt's Space City, AfSA is the primary body for space-related activities across Africa.
              </p>
            </div>
          </div>

          {/* Strategic Pillars Grid */}
          {pillars.length > 0 ? (
            <div className="space-y-16">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                {pillars.map((pillar) => (
                  <article key={pillar.id} className="group">
                    <Link to={`/programmes/strategic-pillars/${pillar.slug}`} className="block">
                      <div className="space-y-4">
                        <div className="overflow-hidden rounded-lg">
                          <img 
                            src={pillar.image}
                            alt={pillar.title}
                            className="w-full h-64 object-cover group-hover:scale-105 transition-transform duration-300"
                          />
                        </div>
                        
                        <div className="space-y-3">
                          <h2 className="text-2xl font-normal font-pt-serif text-gray-900 group-hover:text-wine-100 transition-colors">
                            {pillar.title}
                          </h2>
                          
                          {pillar.description && (
                            <p className="text-base font-normal font-satoshi text-gray-600 leading-relaxed line-clamp-3">
                              <span dangerouslySetInnerHTML={parseHtmlString(pillar.description)} />
                            </p>
                          )}
                          
                          {pillar.tags && pillar.tags.length > 0 && (
                            <div className="flex flex-wrap gap-2 pt-2">
                              {pillar.tags.slice(0, 2).map((tag, index) => (
                                <span
                                  key={index}
                                  className="px-3 py-1 bg-gray-50 rounded-full text-sm font-medium font-satoshi text-gray-700"
                                >
                                  {tag.replace(/_/gi, ' ')}
                                </span>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </Link>
                  </article>
                ))}
              </div>
            </div>
          ) : (
            <div className="text-center py-12">
              <p className="text-gray-500">No strategic pillars available</p>
            </div>
          )}

          {/* Newsletter Section */}
          <div className="mt-16">
            <Newsletter />
          </div>
        </div>

        {/* Sidebar */}
        <div className="space-y-10">
          <RecentArticles />
        </div>
      </div>
    </div>
  )
}